import { animate } from 'motion';
import { AnimatePresence, motion, useMotionTemplate, useMotionValue } from 'motion/react';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PipsReturn from './PipsReturn';
import useClickOutsideSentinel from '../../../../utils/hooks/useClickOutsideSentinel';

const bgStop = 0;
const bgStopHover = 80;

interface NavItemProps {
    children: any,
    to: string,
}

const NavItem: React.FC<NavItemProps> = ({ children, to }) => {
    const barWidth = useMotionValue('0%');
    const scale = useMotionValue(1);
    const handleOnHoverStart = () => {
        animate(barWidth, '100%');
        animate(scale, 1.1);
    };
    const handleOnHoverEnd = () => {
        animate(barWidth, '0%')
        animate(scale, 1);
    };

    return (
        <Link to={to}>
            <motion.li
                className='w-full text-xl relative hover:cursor-pointer'
                onHoverStart={handleOnHoverStart}
                onHoverEnd={handleOnHoverEnd}
            >
                <motion.span style={{ scale }}>{children}</motion.span>

                <div className='absolute top-0 left-0 flex justify-end items-end size-full pointer-events-none'>
                    <motion.div layout style={{ width: barWidth }} className='h-1 mt-1 border-b-2 border-black' />
                </div>
            </motion.li>
        </Link>
    )
}

const HamburgerNav: React.FC = () => {
    const [open, setOpen] = useState(false);
    const hamburgerY = useMotionValue(0);
    const handleOnClick = () => {
        setOpen(!open);
        animate(hamburgerY, [0, 8, 0], { duration: .15 })
    }

    const onClickOutside = () => {
        setOpen(false);
    }

    const ref = useClickOutsideSentinel(onClickOutside);

    return (
        <div
            className='p-1 h-10 flex justify-center items-center shadow-md hover:cursor-pointer relative z-40 bg-clip-text bg-gradient-to-br from-pink-700 to-pink-200'
            onClick={handleOnClick}
        >
            <motion.svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 640"
                className='h-full'
                style={{ y: hamburgerY }}
            >
                <path
                    d="M96 160C96 142.3 110.3 128 128 128L512 128C529.7 128 544 142.3 544 160C544 177.7 529.7 192 512 192L128 192C110.3 192 96 177.7 96 160zM96 320C96 302.3 110.3 288 128 288L512 288C529.7 288 544 302.3 544 320C544 337.7 529.7 352 512 352L128 352C110.3 352 96 337.7 96 320zM544 480C544 497.7 529.7 512 512 512L128 512C110.3 512 96 497.7 96 480C96 462.3 110.3 448 128 448L512 448C529.7 448 544 462.3 544 480z"
                    fill='#b91c1c'
                    stroke='#b91c1c'
                    strokeWidth={4}
                />
            </motion.svg>

            <AnimatePresence>
                {open && (
                    <motion.div
                        key={Math.random()}
                        ref={ref}
                        layout
                        className='absolute -mb-4 -bottom-[200%] right-0 pr-4 pl-6 py-4 rounded-sm bg-white bg-opacity-95 shadow-lg z-50'
                        initial={{ y: -12, opacity: 0, transition: { duration: .15 } }}
                        animate={{ y: 0, opacity: 1, transition: { duration: .15 } }}
                        exit={{ y: -12, opacity: 0, transition: { duration: .15 } }}
                    >
                        <ul className='flex flex-col items-end justify-center gap-y-2 text-nowrap'>
                            <NavItem to='products'>Products</NavItem>
                            <NavItem to='contact'>Contact</NavItem>
                        </ul>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}

const PipsNav: React.FC = () => {
    const backgroundTransparentStop = useMotionValue(bgStop);
    const backgroundTemplate = useMotionTemplate`linear-gradient(to bottom, white, transparent ${backgroundTransparentStop}%, transparent 100%)`
    const fontColor = useMotionValue('#ffffff');

    const handleOnHoverStart = () => {
        animate(backgroundTransparentStop, bgStopHover);
        animate(fontColor, '#111827')
    }

    const handleOnHoverEnd = () => {
        animate(backgroundTransparentStop, bgStop);
        animate(fontColor, '#ffffff')
    }

    return (
        <motion.header
            className='flex justify-between items-center px-2 py-4 z-50 sticky'
            onHoverStart={handleOnHoverStart}
            onHoverEnd={handleOnHoverEnd}
        >
            {/* Background */}
            <motion.div
                className='absolute top-0 left-0 w-full h-[150%] opacity-100 pointer-events-none'
                style={{ background: backgroundTemplate }}
            />

            <div className='h-10'><PipsReturn /></div>
            <Link to='/pips'>
                <motion.p
                    className='text-4xl text-sun select-none hover:cursor-pointer'
                    style={{
                        // color: '#ffb1cf',
                        color: fontColor,
                        filter: 'drop-shadow(0 0 12px black)'
                    }}
                    onHoverStart={handleOnHoverStart}
                >PLANETARY PIPS</motion.p>

            </Link>
            <HamburgerNav />
        </motion.header>
    )
}

export default PipsNav;